module.exports = __webpack_public_path__ + "img/43.176e872b.jpg";